import React, { Component } from 'react'
import { connect } from 'react-redux'

class ResponsiblesContent extends Component {
  constructor(props) {
    super(props)
  }

  renderBusinessUnitResponsible(businessUnitResponsible) {
    let label = process.env.REACT_APP_BUSINESS_UNIT_RESPONSIBLE_LABEL || 'Responsável Corporativo'

    return <p>{label}: {businessUnitResponsible}</p>
  }

  renderAreaResponsible(areaResponsible) {
    let label = process.env.REACT_APP_AREA_RESPONSIBLE_LABEL || 'Responsável Local'

    return <p>{label}: {areaResponsible}</p>
  }

  render() {
    const { areaResponsible, businessUnitResponsible } = this.props
    return(
      <div>
        {!!areaResponsible && this.renderAreaResponsible(areaResponsible)}
        {!!businessUnitResponsible && this.renderBusinessUnitResponsible(businessUnitResponsible)}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  areaResponsible: state.auth.areaResponsible,
  businessUnitResponsible: state.auth.businessUnitResponsible
})

export default connect(mapStateToProps)(ResponsiblesContent)



// WEBPACK FOOTER //
// ./src/components/ResponsiblesContent.js